kv.controller('DashboardWidgetStatsCtrl', function ($element, $attrs, $scope, $injector) {
	let vm = new DashboardWidgetCtrl($element, $attrs, $scope, $injector, function (response) {
		this.value = response;
		this.loading[1] = false;
	});
	return vm;
});
